<template>
  <div>
    <CreateCampaign
      v-if="edit"
      @update="selfUpdate"
    />
    <CampaignPreview
      v-else-if="!edit"
      @update="edit = true"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import CreateCampaign from '../dashboard/CreateCampaign.vue'
import CampaignPreview from './CampaignPreview.vue'

export default {
  components: {
    CreateCampaign,
    CampaignPreview,
  },
  data() {
    return {
      edit: false,
    }
  },
  computed: {
    ...mapGetters(['campaign']),
  },
  async mounted() {
    await this.initData()
  },
  methods: {
    initData() {
      store.dispatch('fetchUserProfile')
    },
    selfUpdate() {
      this.$forceUpdate()
    },
  },
}
</script>

<style>

</style>
